import { CommonModule } from '@angular/common'
import { Component, Input } from '@angular/core'
import { RouterModule } from '@angular/router'
import { Subscription } from 'rxjs'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { ThemeService } from 'src/app/service/theme/theme.service'
import { Media, Themes } from '../../enums/enums'
@Component({
  selector: 'ddc-logo',
  templateUrl: './ddc-logo.component.html',
  styleUrl: './ddc-logo.component.scss',
  imports: [AngularMaterialsModules, CommonModule, RouterModule],
})
export class DdcLogoComponent {
  @Input('hasText') _hasText: boolean
  @Input('size') _size: string
  _ddcLogoSrc: string = Media.ASSETS + 'w1.jpg'

  _isLightTheme: boolean = true
  _isDarkTheme: boolean = false
  _isPaperTheme: boolean = false
  private themeSubscription: Subscription

  constructor(public themeService: ThemeService) {
    this.themeSubscription = this.themeService.theme$.subscribe(theme => {
      this._isLightTheme = theme === Themes.LIGHT
      this._isDarkTheme = theme === Themes.DARK
      this._isPaperTheme = theme === Themes.PAPER
    })
  }
}
